<mat-form-field appearance="outline">
  <mat-label>Naam van Orcaan</mat-label>
  <input
    matInput
    placeholder="Typ een naam..."
    (keyup)="emitKeyUp()"
    [(ngModel)]="query"
    />
    <mat-icon matSuffix>person</mat-icon>
    <mat-hint>Minimaal drie letters...</mat-hint>
  </mat-form-field>

  <div fxLayout="row wrap" fxLayoutAlign="start start">
    @for (member of searchResults; track member) {
      <app-member-summary
        fxFlex="250px"
        fxFlex.lt-sm="100%"
        [member]="member"
        [extraData]="extraData"
        (click)="userClicked(member)"
        >
      </app-member-summary>
    }
  </div>
  @if (searchResults && searchResults.length === 0 && query.length >= 3) {
    <div
      class="col-12 alert alert-warning"
      >
      <p>Geen resultaten gevonden...</p>
    </div>
  }
